// extracted by mini-css-extract-plugin
module.exports = {"link":"style_link__86EMK","icon":"style_icon__KZt1Q","linkStack":"style_linkStack__IwVuB"};